  /**
   * @description 判断是否中文
   * @param str
   * @returns {boolean}
   */
  export function ImgtoString(str) {
      return str.split(',')
  }
/**
   * @description 价格转化千分符
   * @param str
   * @returns {boolean}
   */
  export function priceTo(x) {
      //强制保留两位小数
      var f = parseFloat(x);
      if (isNaN(f)) return false;
      f = Math.round(x* 100) / 100;
      var s = f.toString();
      var rs = s.indexOf( '.');
      if (rs<0) {
        rs = s.length;s += '.';
        while(s.length<(rs+1)+2) {
          s+='0' ;
        }
      }
     
      var leftNum=s.split(".")[0];
      var rightNum="."+s.split(".")[1];
     
      var result;
      var resultArray=[];
      if(leftNum.length>3){
        var i = true;
        while(i){
          resultArray.push(leftNum.slice(-3));
          leftNum=leftNum.slice(0,leftNum.length-3);
          if(leftNum.length<4){
            i=false;
          }
        }
              //由于从后向前截取，所以从最后一个开始遍历并存到一个新的数组，顺序调换
        var sortArray=[];
        for(var ai=resultArray.length-1;ai>=0;ai--){
          sortArray.push(resultArray[ai]);
        }
      
        // 拼接
        result=leftNum+","+sortArray.join(",")+rightNum;
        // //每三位用一个逗号隔开
      }else{
        result=s;
      }
      return result; 
}
/**
   * @description 价格转化千分符
   * @param str
   * @returns {boolean}
   */

   export function Localurl(str){
     var url = location.href.split("?")[0]+str
     history.replaceState(null,null, url);
     return location.href
   }